'use client';

import { useParams } from 'next/navigation';
import React, { FC } from 'react';

import { NewsType } from '@/api/config/types';
import Image from '@/components/core/Image';
import Link from '@/components/core/Link';
import { useTranslation } from '@/hooks/useTranslations';
import './styles.scss';

const BlogItem: FC<NewsType> = ({ logo, date, title, slug, alt }) => {
  const params = useParams();
  const { t } = useTranslation();
  return (
    <div className="newsContentBox">
      <Link href={`/${params.lang}/blog/${slug}`} className="newsBoxImgCont">
        <div className="newsBoxImgContInner">
          <Image alt={alt || 'news'} src={logo} width={500} height={500} className="newsBoxImg" />
        </div>
      </Link>
      <div className="newsBoxTitleWrp">
        <p className="newsBoxTitleText">{title}</p>
        <span className="newsBoxDateText">{date}</span>
      </div>
      <Link href={`/${params.lang}/blog/${slug}`} className="newsBoxBottomRow">
        <p className="newsBoxBottomText">{t('Homepage-Button-Readmore')}</p>
        <i className="bc-i-arrow-right newsIcon" />
      </Link>
    </div>
  );
};

export default BlogItem;
